const getActiveProject = (state) => { return state.activeProject }
const getDefaultProjectName = (state) => { return state.defaultProjectName }
const getLayer = (state) => (layerId = null) => {
  return layerId !== null ? state.layers.find(x => x.layerId === layerId) : state.layers.find(x => x.layerId === state.activeLayerId)
}
const getLayers = (state) => { return state.layers }
const getOptions = (state) => { return state.options }
const getProjectId = (state) => { return state.activeProjectId }
const getStatus = (state) => { return state.status }
const getUploadLayer = (state) => (layerId) => {
  const idx = state.uploadLayers.findIndex(e => e.layerId === layerId)
  return idx !== -1 ? state.uploadLayers[idx] : null
}
const getUploadLayers = (state) => {
  return state.uploadLayers
}

export default {
  getActiveProject,
  getDefaultProjectName,
  getLayer,
  getLayers,
  getOptions,
  getProjectId,
  getStatus,
  getUploadLayer,
  getUploadLayers
}
